import { COIN_VALUE, DIFFICULTY_MODE_SPECS, type DifficultyMode } from '@lk/shared';

export interface ModeEstimate {
  hardCount: number;
  easyCount: number;
  /** Скільки максимум можна заробити, якщо відповісти на все правильно. */
  maxCoins: number;
  completionBonus: number;
  /** 0..1 — очікувана ймовірність успіху в цьому режимі. */
  expectedSuccess: number;
  riskLabel: 'низький' | 'середній' | 'високий';
}

/**
 * ОЦІНКА для екрана вибору — щоб дитина бачила чесний обмін
 * «більший ризик — більша ставка» ще до старту.
 *
 * Це саме оцінка, а не істина: авторитетне `maxCoins` приходить із сервера
 * разом із сесією і одразу замінює це число на екрані.
 */
export function estimateMode(mode: DifficultyMode, length: number): ModeEstimate {
  const spec = DIFFICULTY_MODE_SPECS[mode];
  const hardCount = Math.round(length * spec.hardRatio);
  const easyCount = length - hardCount;
  const maxCoins =
    hardCount * COIN_VALUE.hard + easyCount * COIN_VALUE.easy + spec.completionBonus;

  const expectedSuccess =
    (hardCount * spec.hardTargetSuccess + easyCount * spec.easyTargetSuccess) / Math.max(1, length);

  const riskLabel: ModeEstimate['riskLabel'] =
    expectedSuccess >= 0.8 ? 'низький' : expectedSuccess >= 0.7 ? 'середній' : 'високий';

  return {
    hardCount,
    easyCount,
    maxCoins,
    completionBonus: spec.completionBonus,
    expectedSuccess,
    riskLabel,
  };
}

/** Очікуваний (а не максимальний) заробіток — реалістичне число для підпису. */
export function expectedCoins(mode: DifficultyMode, length: number): number {
  const spec = DIFFICULTY_MODE_SPECS[mode];
  const hardCount = Math.round(length * spec.hardRatio);
  const easyCount = length - hardCount;
  return Math.round(
    hardCount * COIN_VALUE.hard * spec.hardTargetSuccess +
      easyCount * COIN_VALUE.easy * spec.easyTargetSuccess,
  );
}
